import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withRouter, Link } from 'react-router-dom'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as Actions from './store/actions';
import classNames from 'classnames';
import { FuseAnimate, FuseAnimateGroup } from '@fuse';
import _ from 'lodash';

import InfoIcon from '@material-ui/icons/Info';
import LensIcon from '@material-ui/icons/Lens';

import { 
    Card,
    Typography,
    CardContent,
    Divider,
    LinearProgress,
    Button,
    CardActions,
    Icon,
    TextField,
    FormControl,
    InputLabel,
    Select,
    OutlinedInput,
    MenuItem, 
    Popover,
    ListItem,
    List,
    ListSubheader,
    ListItemIcon,
    ListItemText
} from '@material-ui/core';

const styles = theme => ({
    root      : {
        width: '100%'
    },
    header    : {
        background: "linear-gradient(to right, " + theme.palette.primary.dark + " 0%, " + theme.palette.primary.main + " 100%)",
        color     : theme.palette.getContrastText(theme.palette.primary.main)
    },
    headerIcon: {
        position     : "absolute",
        top          : 0,
        left         : 24,
        opacity      : .04,
        fontSize     : 150,
        width        : 150,
        height       : 150,
        pointerEvents: "none"
    },
    content   : {},
    popover: {
        pointerEvents: 'none',
    },
    paper: {
        padding: theme.spacing.unit,
    },
});

class CourseEnrollment extends Component {
    state = {
        filteredCourseList: this.props.courseList,
        enrollmentStatusFilter: "All",
    }
    
    componentDidMount = () => {
        const student_id = this.props.auth.user.data.role_info.link_id;
        
        this.props.getEnrollmentCourseList(student_id);
        this.props.getMajorList();
    }

    componentDidUpdate = (prevProps, prevState) => {
        const { courseList, searchText, majorFilter } = this.props;
        const { enrollmentStatusFilter }              = this.state;
        
        // Only calculate new filteredCourseList if specified props changed
        if(
            !_.isEqual(courseList, prevProps.courseList)
            ||
            !_.isEqual(searchText, prevProps.searchText)
            ||
            !_.isEqual(majorFilter, prevProps.majorFilter)
            ||
            !_.isEqual(enrollmentStatusFilter, prevState.enrollmentStatusFilter)
        ) {
            this.setState({
                filteredCourseList: this.getFilteredCourseList(courseList, searchText, majorFilter, enrollmentStatusFilter)
            });
        }
    }

    getFilteredCourseList = (courseList, searchText, majorFilter, enrollmentStatusFilter) => {
        if (searchText.length === 0 && majorFilter === "All" && enrollmentStatusFilter === "All") return courseList;

        return courseList.filter((course_info) => {
            if (majorFilter !== "All" && (course_info.MajorList.filter((major_info) => major_info.major_id === majorFilter)).length <= 0) {
                return false;
            }

            if (enrollmentStatusFilter !== "All" && 
                (enrollmentStatusFilter === "Enrolled" && !course_info.EnrollmentStatus
                ||
                enrollmentStatusFilter === "Unenrolled" && course_info.EnrollmentStatus)
            ) {
                return false;
            }
            
            if (course_info.CourseName.toLowerCase().includes(searchText.toLowerCase())
                ||
                course_info.CourseDescription.toLowerCase().includes(searchText.toLowerCase())
            ) {
                return true;
            }

            return false;
        });
    }

    handlePopoverOpen = (event, company_calendar_course_id) => {
        this.props.setCoursePopoverAnchor(company_calendar_course_id, event.target);
    }

    handlePopoverClose = (event, company_calendar_course_id) => {
        this.props.setCoursePopoverAnchor(company_calendar_course_id, null);
    }

    setEnrollmentStatusFilter = (enrollmentStatus) => {
        this.setState({
            enrollmentStatusFilter: enrollmentStatus
        });
    }
    
    getPopoverContent = (company_calendar_course_id) => {
        if ( company_calendar_course_id === 0) return '';

        const { filteredCourseList } = this.state;
        const current_course = filteredCourseList.filter((course_info) => course_info.company_calendar_course_id === company_calendar_course_id)[0];

        return (
            <List
                subheader={<ListSubheader component='div'>Related Majors:</ListSubheader>}
            >
                {current_course.MajorList.map((major_info) => (
                    <ListItem key={major_info.major_id}>
                        <ListItemIcon>
                            <LensIcon style={{ fontSize: 10 }} />
                        </ListItemIcon>
                        <ListItemText inset primary={major_info.MajorName} />
                    </ListItem>
                ))}
            </List>
        );
    }

    updateEnrollment = (company_calendar_course_id, company_course_student_rel_id) => {
        const student_id = this.props.auth.user.data.role_info.link_id;

        // Check if student is enrolled
        if (company_course_student_rel_id === 0) {
            this.props.submitStudentEnrollment(student_id, company_calendar_course_id);
        } else {
            this.props.removeStudentEnrollment(student_id, company_calendar_course_id);
        }
    }

    render() {
        const { classes, courseList, theme, searchText, setSearchText, setMajorFilter, majorList, majorFilter } = this.props;
        const { filteredCourseList, enrollmentStatusFilter } = this.state;

        return (
            <div className={classNames(classes.root)}>
                <div className={classNames(classes.header, "relative overflow-hidden flex flex-col items-center justify-center text-center p-16 sm:p-24 h-100 sm:h-144")}>
                    <FuseAnimate animation="transition.slideUpIn" duration={400} delay={100}>
                        <Typography color="inherit" className="text-24 sm:text-40 font-light">
                            Course Enrollment
                        </Typography>
                    </FuseAnimate>

                    <FuseAnimate duration={400} delay={600}>
                        <Typography variant="subtitle1" color="inherit" className="mt-8 sm:mt-16 mx-auto max-w-512">
                            <span className="opacity-75">
                                The following courses are in open enrollment. 
                            </span>
                        </Typography>
                    </FuseAnimate>

                    <Icon className={classes.headerIcon}>school</Icon>
                </div>
            
                <div className={classNames(classes.content, "max-w-2xl w-full mx-auto px-16 sm:px-24 py-24")}>
                    <div className="flex flex-col sm:flex-row items-center justify-between py-24">
                        <TextField
                            label="Search for a course"
                            placeholder="Enter a keyword..."
                            className="flex w-full sm:w-320 mb-16 sm:mb-0 mx-16"
                            value={searchText}
                            inputProps={{
                                'aria-label': 'Search'
                            }}
                            onChange={(event) => setSearchText(event.target.value)}
                            variant="outlined"
                            InputLabelProps={{
                                shrink: true
                            }}
                        />

                        <FormControl className="flex w-full sm:w-320 mx-16" variant="outlined">
                            <InputLabel htmlFor="category-label-placeholder">
                                Course Status Filter
                            </InputLabel>
                            <Select
                                value={enrollmentStatusFilter}
                                onChange={(event) => this.setEnrollmentStatusFilter(event.target.value)}
                                input={
                                    <OutlinedInput
                                        labelWidth={("Course Status Filter".length * 7)}
                                        name="progress"
                                        id="progress-label-placeholder"
                                    />
                                }
                            >
                                <MenuItem value="All">
                                    <em>All</em>
                                </MenuItem>
                                <MenuItem value="Enrolled">
                                    <em>Currently Enrolled</em>
                                </MenuItem>
                                <MenuItem value="Unenrolled">
                                    <em>Enrollment Available</em>
                                </MenuItem>
                            </Select>
                        </FormControl>

                        <FormControl className="flex w-full sm:w-320 mx-16" variant="outlined">
                            <InputLabel htmlFor="category-label-placeholder">
                                Major Filter
                            </InputLabel>
                            <Select
                                value={majorFilter}
                                onChange={(event) => setMajorFilter(event.target.value)}
                                input={
                                    <OutlinedInput
                                        labelWidth={("Major Filter".length * 7)}
                                        name="major"
                                        id="major-label-placeholder"
                                    />
                                }
                            >
                                <MenuItem value="All">
                                    <em>All</em>
                                </MenuItem>

                                {majorList.map((major_info) => (
                                    <MenuItem value={major_info.major_id} key={major_info.major_id}>{major_info.MajorName}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </div>
                    <FuseAnimateGroup
                        enter={{
                            animation: "transition.slideUpBigIn"
                        }}
                        className="flex flex-wrap py-24"
                    >
                        {filteredCourseList.map((course) => {
                            const popover_content = this.getPopoverContent(course.company_calendar_course_id);
                            const is_popover_open = Boolean(course.popoverAnchor);
                            
                            return (
                                <div className="w-full pb-24 sm:w-1/2 lg:w-1/3 sm:p-16" key={course.company_calendar_course_id}>
                                    <Card elevation={1} className="flex flex-col min-h-256">
                                        <div
                                            className="flex items-center justify-between px-24 h-64"
                                            style={{
                                                background: course.Color,
                                                color:      theme.palette.getContrastText(course.Color)
                                            }}
                                        >
                                            <InfoIcon
                                                aria-owns={is_popover_open ? 'mouse-over-popover' : undefined}
                                                aria-haspopup="true"
                                                onMouseEnter={(event) => this.handlePopoverOpen(event, course.company_calendar_course_id)}
                                                onMouseLeave={(event) => this.handlePopoverClose(event, course.company_calendar_course_id)}
                                            />
                                            <Popover
                                                className={classes.popover}
                                                classes={{
                                                    paper: classes.paper,
                                                }}
                                                open={is_popover_open}
                                                anchorEl={course.popoverAnchor}
                                                anchorOrigin={{
                                                    vertical: 'bottom',
                                                    horizontal: 'left',
                                                }}
                                                transformOrigin={{
                                                    vertical: 'top',
                                                    horizontal: 'left',
                                                }}
                                                onClose={this.handlePopoverClose}
                                                disableRestoreFocus
                                            >
                                                {popover_content}
                                            </Popover>
                                            <Typography
                                                style={{
                                                    color: theme.palette.getContrastText(course.Color)
                                                }}
                                            >
                                                Course Size: {course.StudentCount + "/" + course.CourseSizeLimit}
                                            </Typography>
                                        </div>
                                        <CardContent className="flex flex-col flex-1 items-center justify-center">
                                            <Typography className="text-center text-16 font-400">{course.CourseName}</Typography>
                                            {course.Unscheduled === 0 ?
                                                <Typography className="text-center text-13 font-600 mt-4" color="textSecondary">{course.StartDate + ' - ' + course.EndDate}</Typography>
                                                :
                                                <Typography className="text-center text-13 font-600 mt-4" color="textSecondary">{'Self-Paced'}</Typography>
                                            }
                                            {course.EnrollmentStatus ? 
                                                <Typography className="text-center text-13 font-600 mt-4" color="textSecondary">{'Already Enrolled'}</Typography> 
                                                :
                                                null 
                                            }
                                            
                                        </CardContent>
                                        <Divider />
                                        <CardActions className="justify-center">
                                            {/* <Button
                                                onClick={() => this.updateEnrollment(course.company_calendar_course_id, course.company_course_student_rel_id)}
                                                className="justify-start px-32"
                                                color='secondary'
                                                color={course.EnrollmentStatus ? 'primary' : 'secondary'}
                                                // disabled={course.EnrollmentStatus}
                                            >
                                                {course.EnrollmentStatus ? 'Leave Course' : 'Enroll'}
                                            </Button> */}
                                            <Button
                                                className="justify-start px-32"
                                                color={course.EnrollmentStatus ? 'primary' : 'secondary'}
                                                onClick={() => this.props.history.push('/course_enrollment/detail/' + course.company_calendar_course_id)}
                                            >
                                                View Course
                                            </Button>
                                        </CardActions>
                                        {/* <LinearProgress
                                            className="w-full"
                                            variant="determinate"
                                            value={course.Progress}
                                            color="secondary"
                                        /> */}
                                    </Card>
                                </div>
                            )
                        })}
                    </FuseAnimateGroup>
                </div>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getEnrollmentCourseList: Actions.getEnrollmentCourseList,
        setSearchText:           Actions.setSearchText,
        setMajorFilter:          Actions.setMajorFilter,
        getMajorList:            Actions.getMajorList,
        setCoursePopoverAnchor:  Actions.setCoursePopoverAnchor,
        submitStudentEnrollment: Actions.submitStudentEnrollment,
        removeStudentEnrollment: Actions.removeStudentEnrollment,
    }, dispatch);
}

function mapStateToProps({ auth, enrollmentApp }) {
    return {
        auth,
        courseList:  enrollmentApp.enrollment.courseList,
        searchText:  enrollmentApp.enrollment.searchText,
        majorList:   enrollmentApp.enrollment.majorList,
        majorFilter: enrollmentApp.enrollment.majorFilter,
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(CourseEnrollment)));


// WEBPACK FOOTER //
// src/main/content/enrollment/CourseEnrollment.js